import { useMutation } from "@apollo/react-hooks";
import gql from "graphql-tag";
import {
  CreateTask as CreateTaskGenerated,
  CreateTaskVariables as CreateTaskVariablesGenerated,
} from "core/queries/__generated__/CreateTask";

export interface CreateTaskResponse extends CreateTaskGenerated {}
export interface CreateTaskVariables extends CreateTaskVariablesGenerated {}

export const createTask = gql`
  mutation CreateTask(
    $assigneeId: String
    $communicationMethod: String
    $dueAt: RFC3339DateTime
    $name: String!
    $notes: String!
    $preferredCommunicationMethod: String
    $priority: Int
    $recurrenceSettings: TaskRecurrenceSettingsInput
    $subjectId: ID!
    $sourceTaskId: ID
    $tomTaskContextId: Int
    $tomTaskContextCustomUniqueRef: String
    $type: TypeEnum!
    $typeStructuredMetadata: TypeStructuredMetadata
  ) {
    createTask(
      assigneeId: $assigneeId
      dueAt: $dueAt
      communicationMethod: $communicationMethod
      name: $name
      notes: $notes
      preferredCommunicationMethod: $preferredCommunicationMethod
      priority: $priority
      recurrenceSettings: $recurrenceSettings
      subjectId: $subjectId
      sourceTaskId: $sourceTaskId
      tomTaskContextId: $tomTaskContextId
      tomTaskContextCustomUniqueRef: $tomTaskContextCustomUniqueRef
      type: $type
      typeStructuredMetadata: $typeStructuredMetadata
    ) {
      task {
        id
      }
    }
  }
`;

interface UseCreateTaskQueryOptions {
  refetchQueries?: string[];
  awaitRefetchQueries?: boolean;
}
export const useCreateTask = ({
  refetchQueries = [],
  awaitRefetchQueries = false,
}: UseCreateTaskQueryOptions) =>
  useMutation<CreateTaskResponse, CreateTaskVariables>(createTask, {
    refetchQueries,
    awaitRefetchQueries,
  });
